module.exports = __webpack_public_path__ + "static/media/suit_below_img1.aeb3cfc7.png";